const shouldRenderWaypoint = (index = 0, listLength = 0, infiniteIndex = 1, listTotal = 1) => !!(index === listLength - 3 && infiniteIndex !== listTotal);
export default shouldRenderWaypoint;
//# sourceMappingURL=should-render-waypoint.js.map